import { useState, useEffect } from "react";
import { Link, useNavigate } from 'react-router-dom';
// @mui material components
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
// Material Dashboard 2 React components
import MDBox from "common/components/MD/MDBox";
import MDButton from "common/components/MD/MDButton";

import MDTypography from "common/components/MD/MDTypography";


// Material Dashboard 2 React example components
import DashboardLayout from "layouts/DashboardLayout";
import DashboardNavbar from "layouts/components/Navbars/DashboardNavbar";
import Footer from "layouts/components/Footer";
import HeaderForm from "layouts/components/HeaderForm";

//prop-types is a library for typechecking of props
// Data

import DefaultInfoCard from "common/components/implemented/Cards/InfoCards/DefaultInfoCard";
import ExpoPartecipazioniService from "services/API/expo_partecipazioni/ExpoPartecipazioniService";
import base64ToArrayBuffer from "common/script/base64ToArrayBuffer";
import { Alert, AppBar } from "@mui/material";
import MDAlert from "common/components/MD/MDAlert/MDAlert";
import { useMaterialUIController } from "common/context";
import { useFarFieraUIController } from "common/context/FarFieraContext";
import ServiziFieraComponent from "./ServiziFieraComponent";




function ServiziFiera() {

  const [ffcontroller] = useFarFieraUIController();
  const { manifestazione } = ffcontroller;

  const navigate = useNavigate();


const [lista_servizi, setLista_servizi] = useState([{ idServizio: 0, nome_servizio: '' }]);

    

  useEffect(() => {
    carica_servizi();
  }, [manifestazione]);




  function carica_servizi() {
    setLista_servizi([]);
    console.log("Cambiata pp->carico i servizi  :" + manifestazione);
    ExpoPartecipazioniService.seleziona_servizi(manifestazione)
      .then(response => {
       // console.log(response.data);
       
        setLista_servizi(response.data);




      })
      .catch(e => {
        console.log(e);

      });

  }





  const stringa = (<MDTypography
    variant="button"
    fontWeight="regular"
    color="text"
    sx={{ cursor: "pointer", userSelect: "none", ml: -1 }}
  >
    Stampa il contratto e ricaricalo firmato in tutti i suoi punti
    <MDButton onClick={() => navigate("/contratto")} color="success">Vai</MDButton>
  </MDTypography>);

  const [contratto, setContratto] = useState(stringa);


  const modulo_6 = (
    <Link to="https://far.umbriafiere.it/download/6-Moquette-2026.pdf" target="_blank">
      <MDButton variant="outlined" color="success"  >
        6 Moquette/ Pavimentazione / Cielini
      </MDButton>

    </Link>
  );
  const modulo_7 = (
    <Link to="https://far.umbriafiere.it/download/7-Pannelli-Divisori.pdf" target="_blank">
      <MDButton variant="outlined" color="success"  >
        7 Pannelli Divisori
      </MDButton>

    </Link>

  );

  const modulo_8 = (
    <Link to="https://far.umbriafiere.it/download/8-SAF_arredi_e_allestimenti_r.pdf" target="_blank">
      <MDButton variant="outlined" color="success"  >
        8  Arredi
      </MDButton>

    </Link>
  );
  /*
  const modulo_8bis = (
    <Link to="https://far.umbriafiere.it/download/8BIS-Poltrone-e-Vetrine.pdf" target="_blank">
      <MDButton variant="outlined" color="success"  >
        8 BIS Poltrone e Vetrine
      </MDButton>

    </Link>

  );*/

  const modulo_9 = (
    <Link to="https://far.umbriafiere.it/download/9-Materiali-Elettrici.pdf" target="_blank">
      <MDButton variant="outlined" color="success"  >
        9 Materiali Elettrici ed Idraulici
      </MDButton>

    </Link>
  );
  const modulo_10 = (
    <Link to="https://far.umbriafiere.it/download/10-Carrello-Elevatore-Pulizie.pdf" target="_blank">
      <MDButton variant="outlined" color="success"  >
        10 Carrello Elevatore / Pulizia Stand
              </MDButton>

    </Link>

  );

  const modulo_11 = (
    <Link to="https://far.umbriafiere.it/download/11-Noleggio-Gazebo-Prefabbricati-Lavelli_r.pdf" target="_blank">
      <MDButton variant="outlined" color="success"  >
        11 Noleggio Gazebo /Prefabbricati /Lavelli
      </MDButton>

    </Link>
  );

  const modulo_12 = (
    <Link to="https://far.umbriafiere.it/download/12-Noleggio-Apparecchiature-Audio-e-Video.pdf" target="_blank">
      <MDButton variant="outlined" color="success"  >
        12 Noleggio Apparecchiature Audio e Video
      </MDButton>

    </Link>
  );




  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox pt={6} pb={3}>
        <Grid container spacing={6}>

          <Grid item xs={12}>

            <MDBox>
            

              {(lista_servizi && lista_servizi.length>0) &&
                <MDBox>             
                    
                  {lista_servizi.map((servizio) => (
                    <MDBox mt={10}>
                    <ServiziFieraComponent servizio={servizio} />
  </MDBox>
                  ))}
              




                  <MDBox p={10} sx={{ display: 'grid', gap: 10, gridTemplateColumns: '1fr 1fr 1fr' }}>

             
                    <DefaultInfoCard
                      color="success"
                      icon="drawicon"
                      title={modulo_6}
                      description={"Scarica il file, compilalo e invialo all'email indicata"}
                      value=""
                    />

                    <DefaultInfoCard
                      color="success"
                      icon="drawicon"
                      title={modulo_7}
                      description={"Scarica il file, compilalo e invialo all'email indicata"}
                      value=""
                    />
                    <DefaultInfoCard
                      color="success"
                      icon="drawicon"
                      title={modulo_8}
                      description={"Scarica il file, compilalo e invialo all'email indicata"}
                      value=""
                    />
                 
                    <DefaultInfoCard
                      color="success"
                      icon="drawicon"
                      title={modulo_9}
                      description={"Scarica il file, compilalo e invialo all'email indicata"}
                      value=""
                    />
                    <DefaultInfoCard
                      color="success"
                      icon="drawicon"
                      title={modulo_10}
                      description={"Scarica il file, compilalo e invialo all'email indicata"}
                      value=""
                    />
                    <DefaultInfoCard
                      color="success"
                      icon="drawicon"
                      title={modulo_11}
                      description={"Scarica il file, compilalo e invialo all'email indicata"}
                      value=""
                    />
                    <DefaultInfoCard
                      color="success"
                      icon="drawicon"
                      title={modulo_12}
                      description={"Scarica il file, compilalo e invialo all'email indicata"}
                      value=""
                    />
                  </MDBox></MDBox>
              }
 


            </MDBox>
          </Grid>
        </Grid>
      </MDBox>
      <Footer />
    </DashboardLayout>
  );
}



export default ServiziFiera;
